import React from 'react';
import './About.css';
import AboutImageCarousel from './AboutImageCarousel';

const About = () => {
  const handleWhatsApp = () => {
    const message = encodeURIComponent('Olá! Tenho interesse nos serviços da Brilha Piscina. Gostaria de solicitar um orçamento.');
    window.open(`https://wa.me/5521966527607?text=${message}`, '_blank');
  };

  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-content">
          <h1>Técnica, Transparência e Resultado de Verdade</h1>
          
          <p>
            Desde 2021, a Brilha Piscina atua com foco técnico em instalação, manutenção e equipamentos para piscinas no Rio de Janeiro.
          </p>

          <p>
            Não trabalhamos apenas com limpeza. Entregamos prevenção, desempenho e durabilidade para que você não tenha prejuízo com erros de instalação ou manutenção mal feita.
          </p>

          <p>
            Somos especialistas em soluções técnicas para piscinas no RJ. Nossa equipe é treinada para diagnosticar problemas com precisão e indicar a solução correta sem improviso e sem empurrar serviço desnecessário.
          </p>

          <p>
            Utilizamos produtos adequados, equipamentos profissionais e seguimos rigorosamente normas técnicas, garantindo segurança e maior vida útil para sua piscina e seus equipamentos.
          </p>

          <p>
            <strong>Aqui, você fala direto com quem entende do assunto.</strong> Atendimento claro, orçamento transparente e execução bem feita.
          </p>

          <p>
            Se sua piscina precisa de solução, o primeiro passo é um diagnóstico técnico.
          </p>

          <button className="about-whatsapp-btn" onClick={handleWhatsApp}>
            Fale agora pelo WhatsApp e receba sua avaliação
          </button>
        </div>
        
        <div className="about-image">
          <AboutImageCarousel />
        </div>
      </div>
    </section>
  );
};

export default About;
